import { surveyRoutes } from "./survey-routes";

export default (router: any) => {
  surveyRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
